// src/utils/impactScorecardStore.js
// Read/write the per-user IMPACT Scorecard doc at scorecards/{uid}: the carry-
// over goals/why/accountability and the last-used production scope.
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { firestored } from "../firebase/firebaseConfig";

export const SCORECARD_FALLBACK = {
  why: "",
  yearGoals: ["", "", "", ""],
  personalGoals: ["", ""],
  quarterGoals: ["", "", "", ""],
  accountability: "",
  contractsRequired: "",
  lastScope: "me",
};

const refFor = (uid) => doc(firestored, "scorecards", uid);

export async function loadScorecard(uid) {
  if (!uid) return { ...SCORECARD_FALLBACK };
  try {
    const snap = await getDoc(refFor(uid));
    if (!snap.exists()) return { ...SCORECARD_FALLBACK };
    return { ...SCORECARD_FALLBACK, ...(snap.data() || {}) };
  } catch (err) {
    console.error("loadScorecard failed:", err);
    return { ...SCORECARD_FALLBACK };
  }
}

export async function saveScorecard(uid, values) {
  if (!uid) return;
  await setDoc(
    refFor(uid),
    { ...values, updatedAt: serverTimestamp() },
    { merge: true },
  );
}
